"use strict";

define('module/custom_css',{
  init: function () {
    function loadStyle(url) {
      var head = document.getElementsByTagName('head')[0],
          link = document.createElement('link');

      link.rel = 'stylesheet';
      link.media = 'screen';
      link.href = url;

      head.appendChild(link);
    }

    loadStyle('/stylesheets/custom.css');
  }
});
